// extracted by mini-css-extract-plugin
export default {"wrapper":"qr-error-screen_wrapper__yqRa9","title":"qr-error-screen_title__SJpSA","description":"qr-error-screen_description__ByYdn"};